import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

/**
 * Loader component
 */
class E11LoaderComponent {
    constructor() {
        /**
         * Color of the loader
         * @type {string}
         * @default 'primary'
         */
        this.color = 'primary';
        /**
         * Size of the loader
         * @type {string}
         * @default 'md'
         */
        this.size = 'md'; // auto size is dangerous ;) - dont do it
        /**
         * Font size of the loader
         * @type {string}
         * @default '1rem'
         */
        this.fontSize = '1rem'; // string allows override for px or rem
        /**
         * Label of the loader
         * @type {string}
         * @default ''
         */
        this.label = '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11LoaderComponent, isStandalone: true, selector: "e11-loader", inputs: { color: "color", size: "size", fontSize: "fontSize", label: "label" }, ngImport: i0, template: `
    <div
      class="e11-loader-rings-container e11-mx-auto e11-relative e11-flex e11-items-center e11-justify-center"
      [ngClass]="{
        'e11-h-12 e11-w-12': size === 'xs',
        'e11-h-24 e11-w-24': size === 'sm',
        'e11-h-36 e11-w-36': size === 'md',
        'e11-h-48 e11-w-48': size === 'lg',
        'e11-h-56 e11-w-56': size === 'xl'
      }"
    >
      <div class="e11-absolute e11-animate-pulse" style="font-size: {{ fontSize }};">{{ label }}</div>
      <div class="big-ring e11-inline-block e11-relative e11-z-[2]">
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-slate-600': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-gray-400': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-zinc-600': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-stone-300': color === ''
          }"
        ></div>
      </div>
      <div class="little-ring e11-absolute">
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
      </div>
    </div>
  `, isInline: true, styles: [".big-ring{width:100%;height:100%}.big-ring div{box-sizing:border-box;width:100%;height:100%;margin:0 auto;animation:big-ring 1.2s cubic-bezier(.5,0,.5,1) infinite}.big-ring div:nth-child(1){animation-delay:-.45s}.big-ring div:nth-child(2){animation-delay:-.3s}.big-ring div:nth-child(3){animation-delay:-.15s}@keyframes big-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.little-ring{width:100%;height:100%}.little-ring div{box-sizing:border-box;width:100%;height:100%;margin:0 auto;padding:4px;border-radius:50%;animation:little-ring 3s cubic-bezier(.5,0,.5,1) infinite}.little-ring div:nth-child(1){animation-delay:-.25s}.little-ring div:nth-child(2){animation-delay:-.4s}.little-ring div:nth-child(3){animation-delay:-.25s}@keyframes little-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-loader', standalone: true, imports: [CommonModule], template: `
    <div
      class="e11-loader-rings-container e11-mx-auto e11-relative e11-flex e11-items-center e11-justify-center"
      [ngClass]="{
        'e11-h-12 e11-w-12': size === 'xs',
        'e11-h-24 e11-w-24': size === 'sm',
        'e11-h-36 e11-w-36': size === 'md',
        'e11-h-48 e11-w-48': size === 'lg',
        'e11-h-56 e11-w-56': size === 'xl'
      }"
    >
      <div class="e11-absolute e11-animate-pulse" style="font-size: {{ fontSize }};">{{ label }}</div>
      <div class="big-ring e11-inline-block e11-relative e11-z-[2]">
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-slate-600': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-gray-400': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-zinc-600': color === ''
          }"
        ></div>
        <div
          class="e11-block e11-absolute e11-rounded-full e11-border-8 e11-border-r-transparent e11-border-b-transparent e11-border-l-transparent"
          [ngClass]="{
            'e11-border-t-skin-primary': color === 'primary',
            'e11-border-t-skin-primary-accent': color === 'primary-accent',
            'e11-border-t-skin-secondary': color === 'secondary',
            'e11-border-t-stone-300': color === ''
          }"
        ></div>
      </div>
      <div class="little-ring e11-absolute">
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
        <div class="e11-block e11-absolute e11-border-t e11-border-gray-400"></div>
      </div>
    </div>
  `, styles: [".big-ring{width:100%;height:100%}.big-ring div{box-sizing:border-box;width:100%;height:100%;margin:0 auto;animation:big-ring 1.2s cubic-bezier(.5,0,.5,1) infinite}.big-ring div:nth-child(1){animation-delay:-.45s}.big-ring div:nth-child(2){animation-delay:-.3s}.big-ring div:nth-child(3){animation-delay:-.15s}@keyframes big-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.little-ring{width:100%;height:100%}.little-ring div{box-sizing:border-box;width:100%;height:100%;margin:0 auto;padding:4px;border-radius:50%;animation:little-ring 3s cubic-bezier(.5,0,.5,1) infinite}.little-ring div:nth-child(1){animation-delay:-.25s}.little-ring div:nth-child(2){animation-delay:-.4s}.little-ring div:nth-child(3){animation-delay:-.25s}@keyframes little-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }], fontSize: [{
                type: Input
            }], label: [{
                type: Input
            }] } });

class E11LoaderModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderModule, imports: [E11LoaderComponent], exports: [E11LoaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderModule, imports: [E11LoaderComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11LoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [E11LoaderComponent],
                    exports: [E11LoaderComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11LoaderComponent, E11LoaderModule };
